import { Component, Input, OnInit } from '@angular/core';
import { FormFieldConfig, FormTemplateGroup } from '../../form-template-model';
import { FormTemplateGeneratorService } from '../form-template-generator.service';
import { FormTemplateGroupFormGroup } from './../../form-template-form-group';
import { formTemplateGenericSort } from './../../form-template-model';

@Component({
  selector: 'csi-form-template-group-generator',
  templateUrl: './form-template-group-generator.component.html',
  styleUrls: ['./form-template-group-generator.component.css']
})
export class FormTemplateGroupGeneratorComponent implements OnInit {
  @Input() formTemplateGroup: FormTemplateGroup;
  @Input() formTemplateGroupFormGroup: FormTemplateGroupFormGroup;
  @Input() readOnly: boolean = false;
  @Input() formatForPDF: boolean = false;
  @Input() supportingFields: { [key: string]: FormFieldConfig };
  @Input() country = null;
  @Input() isPatientView = false;

  sortFields = formTemplateGenericSort;
  constructor(public formTemplateGeneratorService: FormTemplateGeneratorService) {}

  ngOnInit() {}
}
